import { render, staticRenderFns } from "./PrePostComplement.vue?vue&type=template&id=4c167b3e&scoped=true"
import script from "./PrePostComplement.vue?vue&type=script&lang=js"
export * from "./PrePostComplement.vue?vue&type=script&lang=js"
import style0 from "./PrePostComplement.vue?vue&type=style&index=0&id=4c167b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c167b3e",
  null
  
)

export default component.exports